<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>Mensagens personalizadas</v-subheader>
        <v-divider/>
        <px-mensagens-personalizadas-list
          hide-header
          :messages="requisicao.mensagensPersonalizadas"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
};
</script>
